import { render, staticRenderFns } from "./SportEventMarkets.vue?vue&type=template&id=58382d74&"
import script from "./SportEventMarkets.vue?vue&type=script&lang=js&"
export * from "./SportEventMarkets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports